import React, {useEffect, useRef} from 'react';
import {Dropdown} from 'react-bootstrap';
import {CapabilityOption} from './types';
import {SvgIcon} from '../../icons/svgIcon';
import {Icons} from '../../icons/icons';
import {HibuTooltip} from '../../common/hibuTooltip/hibuTooltip';

export type ChatInputCommandsProps = {
    options: CapabilityOption[];
    onSelectCommand: (command: string | null) => void;
    isOpen: boolean;
    setFocus: boolean;
    onToggle: (nextShow: boolean) => void;
};

export const ChatInputCommands = ({
                                      options,
                                      isOpen,
                                      setFocus,
                                      onSelectCommand,
                                      onToggle,
                                  }: ChatInputCommandsProps): React.JSX.Element => {
    const firstItemRef = useRef<HTMLAnchorElement>(null);

    useEffect(() => {
        if (isOpen && setFocus) {
            firstItemRef.current?.focus();
        }
    }, [isOpen, setFocus]);

    return (
        <HibuTooltip tooltipKey="assistant.capabilities.menu-trigger" placement="top">
            <Dropdown
                id="assistant-command-trigger"
                drop="up"
                className="assistant-command-trigger"
                onSelect={(eventKey) => onSelectCommand(eventKey)}
                show={isOpen}
                onToggle={(nextShow) => onToggle(nextShow)}
            >
                <Dropdown.Toggle id="chat-input-toggle">
                    <SvgIcon icon={Icons.ALTERNATE_EMAIL} id="chat-input-mention" className="chat-input-mention"/>
                </Dropdown.Toggle>
                <Dropdown.Menu align="end" className="commands-menu">
                    {options.map((option) => {
                        return (
                            <Dropdown.Item key={option.commandLabel} eventKey={option.type} ref={firstItemRef}>
                                {option.label}
                            </Dropdown.Item>
                        );
                    })}
                </Dropdown.Menu>
            </Dropdown>
        </HibuTooltip>
    );
};
